import Vue from 'vue';
import axios from 'axios';
import _ from 'lodash';
import VuePaginate from 'vue-paginate'
import cardAccordion from './components/card-accordion';
import MemberTierFilter from './components/MemberTierFilter';
import { EventBus } from './event-bus';
Vue.use(VuePaginate);

Vue.component('member-summary', {
    props: ['summary'],
    data() {
        return {
            showShortVersion: true,
        };
    },
    computed: {
        showSummary() {
            return this.showShortVersion
                ? _.truncate(this.summary, {
                    length: 275,
                })
                : this.summary;
        },
    },
    methods: {
        showFullSummary() {
            this.showShortVersion = false;
        },
    },
    template: `<p class="card-accordion__summary">
                    {{showSummary}}
                    <a v-if="showShortVersion && (summary && summary.length) > 275" v-on:click="showFullSummary">Read more</a>
                </p>`,
});

export default (() => {
    if (document.querySelector('#current-members')) {
        new Vue({
            el: '#current-members',
            delimiters: ['${', '}'],
            components: {
                cardAccordion,
                MemberTierFilter,
                VuePaginate,
            },
            data: {
                query: '',
                levels: [],
                activeLevel: 'all',
                activeLevelTitle: 'all',
                membersByLevel: [],
                membersByTier: [],
                isSearching: true,
                activeCardIds: [],
                selectedTier: 'all',
                paginate: ['professional-services','individual'],
            },
            computed: {
                levelsToShow() {
                    let memberLevels = [...this.membersByLevel];
                    if (this.activeLevel === 'all') {
                        const allLevels = _.filter(memberLevels, level => level.members.length > 0 && level.meta.level == 1);
                        return allLevels;
                    } else {
                        let filteredLevels;
                        if (this.membersByTier.length > 0 && this.selectedTier !== 'all') {
                            filteredLevels = this.membersByTier;
                        } else {
                            filteredLevels = _.filter(memberLevels, level => this.activeLevel === level.meta.slug);
                        }
                        return filteredLevels;
                    }
                },
                totalMembers() {
                    return _.sumBy(this.membersByLevel, o => o.meta.pagination ? o.meta.pagination.total : o.members.length);
                },
            },
            beforeMount() {
                // Fetch levels
                axios.get('/api/memberlevels.json')
                    .then((response) => {
                        this.levels = response.data.data;
                        this.search();
                    });
            },
            mounted() {
                EventBus.$on('set-filter', this.updateFilter);
            },
            destroyed() {
                EventBus.$off('set-filter', this.updateFilter);
            },
            methods: {
                toggleActiveCard(id) {
                    const index = this.activeCardIds.indexOf(id);
                    if (index === -1) {
                        this.activeCardIds.push(id);
                    } else {
                        this.activeCardIds.splice(index, index + 1);
                    }
                },
                addActiveCards(members) {
                    members.forEach((group) => {
                        if (group.meta.slug === 'sponsoring') {
                            group.members.forEach(member => this.activeCardIds.push(member.id));
                        }
                    });
                },
                search(query = '') {
                    this.isSearching = true;

                    const newMembers = [];
                    const promises = [];

                    this.levels.forEach(level => {
                        if (level.level === "1") {
                            if (level.slug === 'professional-services' || level.slug === 'individual') {
                                promises.push(axios.get(`/api/members/${level.slug}.json?query=${query}`));
                            } else {
                                promises.push(axios.get(`/api/members/${level.slug}.json?query=${query}&paginate=true`));
                            }
                        }
                    });

                    axios.all(promises)
                        .then((results) => {
                            results.forEach((response) => {
                                if (response.data.meta.slug === 'professional-services' || response.data.meta.slug === 'individual') {
                                    response.data.members =  _.orderBy(response.data.members, 'tier', 'desc');
                                }
                                newMembers.push(response.data);
                            });

                            this.membersByLevel = newMembers;
                            this.addActiveCards(this.membersByLevel);
                            this.showLevel('all');
                            this.isSearching = false;
                        });
                },
                clearSearch() {
                    this.query = '';
                    this.search();
                },
                showLevel(level, title) {
                    this.selectedTier = 'all';
                    this.membersByTier = [];
                    this.activeLevel = level;
                    this.activeLevelTitle = title;
                },
                hasLink(level, link) {
                    if (level.meta.pagination.links) {
                        return Object.prototype.hasOwnProperty.call(level.meta.pagination.links, link);
                    }
                },
                memberPaginate(slug, link) {
                    this.isSearching = true;
                    let membersByLevel = [];
                    let savedLevel = '';

                    membersByLevel = [...this.membersByLevel];

                    if ((this.activeLevel === 'professional-services' || this.activeLevel === 'individual')
                        && (this.membersByTier.length > 0 && this.selectedTier !== 'all')) {
                            membersByLevel = [...this.membersByTier];
                            savedLevel = _.find(membersByLevel, ['meta.slug', slug]);
                            this.fetchMembers(link, membersByLevel, 'byTier', savedLevel);
                    } else {
                        savedLevel = _.find(membersByLevel, ['meta.slug', slug]);
                        this.fetchMembers(link, membersByLevel, 'byLevel', savedLevel);
                    }
                },
                fetchMembers(link, currentMemberList, listType, savedLevel) {
                    axios.get(link)
                        .then((response) => {
                            currentMemberList[currentMemberList.indexOf(savedLevel)] = response.data;
                            if (listType === 'byTier') {
                                this.membersByTier = currentMemberList;
                            }else{
                                this.membersByLevel = currentMemberList;
                            }
                            this.isSearching = false;
                        });
                },
                toggleShow(event) {
                    event.currentTarget.closest('.card-accordion').classList.toggle('toggled');
                },
                updateFilter(val) {
                    const newMembers = [];
                    const promises = [];
                    this.selectedTier = val;
                    if (this.activeLevel === 'professional-services' || this.activeLevel === 'individual') {
                        this.isSearching = true;
                        if (this.selectedTier !== 'all') {
                            promises.push(axios.get(`/api/members/${this.activeLevel}.json?query=${this.query}&tier=${val}&paginate=true`));
                            axios.all(promises)
                                .then((results) => {
                                    results.forEach((response) => {
                                        newMembers.push(response.data);
                                    });
                                    this.membersByTier = newMembers;
                                    this.isSearching = false;
                                });
                        } else {
                            this.isSearching = false;
                        }
                    }
                }
            },
        });
    }
})();
